import { InstagramConversationDto } from "./InstagramConversationDto";
import { InstagramConversationModel } from "./InstagramConversationModel";

export const transformInstagramConversationDtoToModel = (
  dto: InstagramConversationDto
): InstagramConversationModel => dto;
